<template>
  <main class="flex flex-col items-center">
    <div
      class="plane-animation text-gold text-7xl md:text-8xl lg:text-9xl relative z-10"
    >
      <font-awesome-icon icon="fa-solid fa-paper-plane" />
    </div>

    <p class="mt-10 text-base md:text-lg font-semibold text-center">
      {{
        lang === "mn"
          ? "Хүсэлт амжилттай илгээгдлээ."
          : "Successfully sent the registration request!"
      }}
    </p>

    <div class="flex max-sm:flex-col gap-3 sm:gap-5 mt-3">
      <button
        @click="startAgain()"
        class="border border-black text-black p-3 rounded text-sm"
      >
        <font-awesome-icon icon="fa-solid fa-pen-fancy" class="mr-1" />
        {{ lang === "mn" ? "Дахин хүсэлт илгээх" : "Submit again" }}
      </button>

      <router-link
        to="/yp"
        class="bg-gold text-black p-3 rounded text-sm hover:shadow-md"
      >
        <font-awesome-icon icon="fa-solid fa-house" class="mr-1" />
        {{ lang === "mn" ? "Нүүр хуудас руу буцах" : "Return to home page" }}
      </router-link>
    </div>
  </main>
</template>

<script>
import { computed } from "vue";
import { useStore } from "vuex";

export default {
  name: "YellowRegistrationSuccessful",
  emits: ["startAgain"],
  setup(_, { emit }) {
    const store = useStore();
    const lang = computed(() => store.getters.getLanguage);

    const startAgain = () => {
      emit("startAgain");
    };

    return { lang, startAgain };
  },
};
</script>

<style scoped>
@keyframes flyUpRightAndReturnFromLeft {
  0% {
    transform: translate(0, 0) rotate(0deg);
    opacity: 1;
  }
  40% {
    transform: translate(300px, -200px) rotate(30deg);
    opacity: 0;
  }
  41% {
    transform: translate(-300px, -200px) rotate(-30deg);
    opacity: 0;
  }
  100% {
    transform: translate(0, 0) rotate(0deg);
    opacity: 1;
  }
}

.plane-animation {
  animation: flyUpRightAndReturnFromLeft 2.5s ease-in-out forwards;
}
</style>
